import { render, staticRenderFns } from "./ExportDispatchOverview.vue?vue&type=template&id=06b76de9&scoped=true"
import script from "./ExportDispatchOverview.vue?vue&type=script&lang=js"
export * from "./ExportDispatchOverview.vue?vue&type=script&lang=js"
import style0 from "./ExportDispatchOverview.vue?vue&type=style&index=0&id=06b76de9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b76de9",
  null
  
)

export default component.exports